export default __webpack_public_path__ + "static/media/health3.c7450267.png";